import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiSearch } from 'react-icons/fi';
import './DomainCheck.css';

const extensions = ['.com', '.net', '.org', '.io', '.dev', '.co', '.me', '.info'];

const DomainCheck = () => {
  const { t } = useTranslation();
  const [domain, setDomain] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (domain.trim()) {
      window.open(
        `https://portal.roolink.net/cart.php?a=add&domain=register&query=${encodeURIComponent(domain.trim())}`,
        '_blank'
      );
    }
  };

  return (
    <section id="domain-check" className="section domain-section bg-gradient">
      <div className="domain-bg-elements">
        <div className="domain-circle c1"></div>
        <div className="domain-circle c2"></div>
        <div className="domain-grid-pattern"></div>
      </div>
      <div className="container text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="section-tag" style={{ background: 'rgba(255,255,255,0.15)', color: '#fff' }}>
            {t('domainCheck.sectionTag')}
          </span>
          <h2 className="section-title" style={{ color: '#fff' }}>{t('domainCheck.title')}</h2>
          <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.7)' }}>
            {t('domainCheck.subtitle')}
          </p>
        </motion.div>

        <motion.form
          className="domain-search-form"
          onSubmit={handleSearch}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <div className="domain-input-wrapper">
            <FiSearch className="domain-search-icon" />
            <input
              type="text"
              className="domain-input"
              placeholder={t('domainCheck.placeholder')}
              value={domain}
              onChange={(e) => setDomain(e.target.value)}
            />
            <motion.button
              type="submit"
              className="domain-search-btn"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {t('domainCheck.button')}
            </motion.button>
          </div>
        </motion.form>

        <motion.div
          className="domain-extensions"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <p className="extensions-label">{t('domainCheck.extensions')}</p>
          <div className="extensions-list">
            {extensions.map((ext, idx) => (
              <motion.span
                key={ext}
                className="extension-badge"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: 0.5 + idx * 0.05 }}
                whileHover={{ scale: 1.1 }}
              >
                {ext}
              </motion.span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DomainCheck;
